module.exports = __webpack_public_path__ + "public/images/header-slide-1.15a2d99552e2bc5fa8758f79567b8f1c.jpg";